import React from "react";
import "./notificationIcon.scss";

interface NotificationIconProps {
  notifications?: number;
  small?: boolean;
}

const NotificationIcon = ({ notifications, small }: NotificationIconProps) => {
  if (!notifications) {
    return null;
  }
  return <div className={small ? "notification-icon-small" : "notification-icon"}>{notifications}</div>;
};

export default NotificationIcon;
